export default __webpack_public_path__ + "static/media/girl-hostel-1.ead350d0.jpg";